<template>
  <div>
    <!-- Header -->
    <div v-if="renderHeaders(index)" v-html="renderHeaders(index)"></div>

    <!-- Block Row View -->
    <div v-if="questionLayout == 'standard-block-row'">
      <div class="text-site-primary">
        {{ index }}.
        <span v-html="renderWithImages(examItem.question)" />
      </div>
      <b-form-radio-group v-model="selected" :name="itemFormName">
        <b-form-radio
          class="d-block ml-4"
          v-for="choice in choices"
          :key="choice.value"
          :value="choice.value"
        >
          <span v-html="renderWithImages(choice.text)" />
        </b-form-radio>
      </b-form-radio-group>
      <b-form-input
        v-model="selected"
        v-if="choices.length == 0"
        type="number"
        :name="itemFormName"
      />
    </div>

    <!-- Block Row View -->
    <div v-if="questionLayout == 'standard-block-row-italchoices'">
      <div class="text-site-primary">
        {{ index }}.
        <span v-html="renderWithImages(examItem.question)" />
      </div>
      <b-form-radio-group v-model="selected" :name="itemFormName">
        <b-form-radio
          class="d-block ml-4"
          v-for="choice in choices"
          :key="choice.value"
          :value="choice.value"
        >
          <span class="font-italic" v-html="renderWithImages(choice.text)" />
        </b-form-radio>
      </b-form-radio-group>
      <b-form-input
        v-model="selected"
        v-if="choices.length == 0"
        type="number"
        :name="itemFormName"
      />
    </div>

    <!-- Block Row View Tight -->
    <div v-else-if="questionLayout == 'oneline-md-2'">
      <div class="row">
        <div class="col-md-2">
          <div class="text-site-primary">
            {{ index }}.
            <span v-html="renderWithImages(examItem.question)" />
          </div>
        </div>
        <div class="col-md-10">
          <b-form-radio-group v-model="selected" :name="itemFormName">
            <div class="row h-100">
              <div class="col-md-2" v-for="choice in choices" :key="choice.value">
                <b-form-radio :value="choice.value">
                  <span v-html="renderWithImages(choice.text)" />
                </b-form-radio>
              </div>
            </div>
          </b-form-radio-group>
          <b-form-input
            v-model="selected"
            v-if="choices.length == 0"
            type="number"
            :name="itemFormName"
          />
        </div>
      </div>
    </div>

    <!-- Block Row View Grouped -->
    <div v-else-if="questionLayout == 'oneline-md-5'">
      <div class="row">
        <div class="col-md-5">
          <div class="text-site-primary">
            {{ index }}.
            <span v-html="renderWithImages(examItem.question)" />
          </div>
        </div>
        <div class="col-md-7">
          <b-form-radio-group v-model="selected" :name="itemFormName">
            <div class="row h-100">
              <div class="col-md-1" v-for="choice in choices" :key="choice.value">
                <b-form-radio :value="choice.value" >
                  <span v-html="renderWithImages(choice.text)" />
                </b-form-radio>
              </div>
            </div>
          </b-form-radio-group>
          <b-form-input
            v-model="selected"
            v-if="choices.length == 0"
            type="number"
            :name="itemFormName"
          />
        </div>
      </div>
      <hr v-if="index % 4 == 0" />
    </div>
    <!-- Single Digit -->
    <div v-else-if="questionLayout == 'number-single-digit'">
      <div class="text-site-primary">
        {{ index }}.
        <span v-html="renderWithImages(examItem.question)" />
      </div> 
      <b-form-input
      class="w-25"
        v-model="selected"
        v-if="choices.length == 0"
        maxlength="1"
        :name="itemFormName"
      />
    </div>

    <!-- Standard View -->
    <div v-else>
      <div class="text-site-primary">
        {{ index }}.
        <span v-html="renderWithImages(examItem.question)" />
      </div>
      <b-form-radio-group v-model="selected" :name="itemFormName">
        <b-form-radio v-for="choice in choices" :key="choice.value" :value="choice.value">
          <span v-html="renderWithImages(choice.text)" />
        </b-form-radio>
      </b-form-radio-group>
      <b-form-input
        v-model="selected"
        v-if="choices.length == 0"
        type="number"
        :name="itemFormName"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    examItem: {
      type: Object,
      required: true,
    },
    questionLayout: {
      type: String,
      default: "standard",
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    itemFormName() {
      return `examItem${this.examItem.id}`;
    },
    choices() {
      const choiceArray = [];
      var choiceIndex = 1;
      var keepGoing = true;
      while (keepGoing) {
        const choice = this.examItem[`choice${choiceIndex}`];
        if (!choice) {
          keepGoing = false;
        } else {
          choiceArray.push({
            text: choice,
            value: choiceIndex,
          });
          choiceIndex++;
        }
      }
      return choiceArray;
    },
  },
  watch: {
    selected(newValue) {
      if (this.choices.length > 0)
        this.$emit(`saveAnswer`, this.examItem.id, this.index, newValue);
      else this.$emit(`saveAnswer`, this.examItem.id, this.index, 0, newValue);
    },
  },
  methods: {
    renderWithImages(text) {
      if (text.indexOf(`::img::`) > -1) {
        var textArr = text.split(`::img::`);
        var imageCount = textArr.length;
        for (var x = 1; x < imageCount; x++ && x++) {
          var metadata = JSON.parse(textArr[x]);
          textArr[x] = `<div class="img-box"><img class="${
            metadata.class
          }" id="${metadata.id}" src="${this.$store.getters[
            "examItem/getImage"
          ](metadata.key)}" /></div>`;
        }
        text = textArr.join("");
      }

      return text;
    },
    renderHeaders(questionNumber) {
      return this.$store.getters["examItem/getHeader"](
        `e${this.examItem.examId}q${questionNumber}`
      );
    },
  },
};
</script>

<style lang="css">
.choice-img {
  width: 70px;
  height: auto;
}
.exam8-img.question-img {
  max-width: 25rem;
  height: auto;
}
.exam8-img.choice-img {
  max-height: 7rem;
  width: auto;
}

.exam8-img.choice-img {
  max-height: 7rem;
  width: auto;
}

.exam9-img.sample-img {
  max-width: 4rem;
  height: auto;
}
.exam9-img.question-img {
  max-width: 4rem;
  height: auto;
}
</style>  